import React from "react";
import { Table, Typography } from "antd";
import { ImperativeModel } from "src/data/models/ImperativeModel";
import { useDarkMode } from "src/context/DarkModeContext";

const { Title } = Typography;

const personsImperative = ["Tú", "Usted", "Nosotros", "Vosotros", "Ustedes"];

interface ImperativeTableProps {
    verbData: ImperativeModel;
}

const ImperativeTable: React.FC<ImperativeTableProps> = ({ verbData }) => {
    const { isDarkMode } = useDarkMode();

    const dataSource = personsImperative.map((person, index) => ({
        key: index,
        person,
        affirmative: verbData.affirmativeForms[index],
        negative: verbData.negativeForms[index],
    }));

    const columns = [
        {
            title: "Person",
            dataIndex: "person",
            key: "person",
        },
        {
            title: "✅ Affirmative",
            dataIndex: "affirmative",
            key: "affirmative",
            align: "center" as const,
        },
        {
            title: "❌ Negative",
            dataIndex: "negative",
            key: "negative",
            align: "center" as const,
        },
    ];

    return (
        <div
            style={{
                maxWidth: "850px",
                margin: "8px auto",
                background: isDarkMode ? "rgba(2, 15, 33, 0.2)" : "",
                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.15)",
            }}
        >
            <div style={{ textAlign: "center", marginTop: "20px", }}>
                <Title level={5} style={{ color: isDarkMode ? "white" : "black", marginBottom: "16px" }}>
                    {verbData.verb}
                </Title>
            </div>
            <Table
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                size="small"
                bordered
            />
        </div>
    );
};

export default ImperativeTable;
